import React from "react";
import { FormSectionElements, FormSections, FormSubSections, ProgramContainer } from "../../../entities/formTemplateDataType";
import { SubSectionComponent } from "../../SubSectionComponent";
import { parseJson, stringifyJson } from "../../../utilities/JsonUtils";
import FormValidationUtils from "../../../utilities/FormValidationUtils";
import { ErrorAlertsComponent } from "../../odsCalloutBox/ErrorAlertsComponent";
import StepIndicator  from '../step-indicator/StepIndicator';  
import { SpinnerComponent } from "../../../commonComponent/SpinnerComponent";
import { is } from "date-fns/locale";

interface Props {
  programContainer: ProgramContainer;
  isEng: boolean;
  parentRef?: any;
  callback?: (programContainer: ProgramContainer) => void;
  callbackStepIndex?: (index: number) => void;
  isPrint?: boolean;
  }

interface State {
  validationErrMsg?: any[];
  isSubmit?: boolean;
  submitProgress?: number;
  isBusy?: boolean;
}
const getSequencedSteps = (programContainer: ProgramContainer): FormSections[] => {
  // Exclude the last item by index, not by object reference
  return programContainer?.ListOfFormSections?.filter(
    (p, idx, arr) =>
      p.Visible &&
      !p.NotStep &&
      !p.IsTechErrorPage &&
      !p.IsInfoPage &&
      !p.IsConfirmationPage &&
      !p.IsTerminationPage &&
      idx !== arr.length - 1
  );
}
const getCustomizedSummaryComponentStep = (programContainer: ProgramContainer): number => {
    const steps = getSequencedSteps(programContainer);
     return steps.length > 0 ? steps.length : 0
}

export class BXPSummaryComponent extends React.Component<Props, State> {
  HtmlToReactParser = require('html-to-react').Parser;
  htmlToReactParser = new this.HtmlToReactParser();
  parsedCustomHeader: any;
  state: State = {
    validationErrMsg: [],
    isSubmit: false,
    submitProgress: 0,
    isBusy: false,
  };
  showComplete: boolean = this.props.programContainer?.CategoryId.toLowerCase() === 'bxp-016-1000';

  originalProgramContainer: ProgramContainer | null = null;

  static defaultProps: Partial<Props> = {
    isPrint: false,
  };
  formSections: FormSections[] =
    this.props.programContainer?.ListOfFormSections ?? [];

  lastIdx: number = this.formSections.length - 1;

  ReviewHtmlString = [];

  programContainer = parseJson(
    stringifyJson(
      this.props.programContainer,
      this.props.programContainer.CategoryId
    ),
    this.props.programContainer.CategoryId
  ) as ProgramContainer;

  constructor(props: Props) {
    super(props);
    this.formSections = this.props.programContainer.ListOfFormSections;
  }

render() {
  this.ReviewHtmlString = [];

  const parser = new DOMParser();
  const stepNumer: number | null = getCustomizedSummaryComponentStep(this.props.programContainer);
  
  // Prepare section list for the StepIndicator
  const sectionList = [
    ...this.programContainer.ListOfFormSections.filter(
      (p, idx, arr) => p.Visible && idx !== arr.length - 1
    ),
    this.programContainer.ListOfFormSections[this.programContainer.ListOfFormSections.length - 1]
  ];

  //Application Header for pdf
  let applicationHeaderSlot = null;

    const appheaderHtmlString = this.props.isEng
      ? this.props.programContainer.CustomApplicationHeader
      : this.props.programContainer.CustomApplicationHeaderFRA;
    
    const doc = parser.parseFromString(appheaderHtmlString, "text/html");
    const header = doc.querySelector(".ministry-header");
    let styleTag = doc.querySelector("style");
    const title = doc.querySelector(".main-title");
    const agreement = doc.querySelector(".agreement");

    if (header) header.className = "ministry-header-pdf";
    if (title) {
      title.className = "main-title-pdf";
      title.innerHTML = title.innerHTML.replace(/<br\s*\/?>/gi, ' ');
    }
    if (agreement) agreement.className = "agreement-pdf";

    let styleHtml = styleTag ? styleTag.outerHTML : "";

    applicationHeaderSlot = (
      <div key="app-header-slot">
        {header || title || agreement ? (
          <>
            {header && this.htmlToReactParser.parse(styleHtml + header.outerHTML)}
            {title && this.htmlToReactParser.parse(styleHtml + title.outerHTML)}
            {agreement && this.htmlToReactParser.parse(styleHtml + agreement.outerHTML)}
          </>
        ) : (
          this.htmlToReactParser.parse(appheaderHtmlString)
        )}
      </div>
    );
    this.ReviewHtmlString.push(applicationHeaderSlot);


  //Review Summary Header
  const customReviewHtmlString = this.props.isEng
    ? this.props.programContainer.CustomSummaryHeader
    : this.props.programContainer.CustomSummaryHeaderFRA;
  
  const reviewdoc = parser.parseFromString(customReviewHtmlString, "text/html");
  const review = reviewdoc.querySelector(".review");
  const description = reviewdoc.querySelector(".description");
  styleTag = reviewdoc.querySelector("style");

  if (review ) review.className = "review-pdf";
  if (description ) description.className = "description-pdf";

  styleHtml = styleTag ? styleTag.outerHTML : "";
  const summaryHeaderSlot = (
    <div key="summary-header-slot">
      {review ? (
        <>
          {this.htmlToReactParser.parse(styleHtml + review.outerHTML)}
          {this.htmlToReactParser.parse(styleHtml + description.outerHTML)}
        </>
      ) : (
        this.htmlToReactParser.parse(customReviewHtmlString)
      )}
    </div>
  );
  this.ReviewHtmlString.push(summaryHeaderSlot);

  // Generate subSectionsContent
  const subSectionsContent = [];
  const subSectionsContentForHtml = [];
  let idx = 0;
  for (let i = 1; i < this.formSections.length; i++) {
    const section = this.formSections[i];
    if (section.Visible) { 
      idx++;
    }
    if (i === this.lastIdx) {
      section.Visible = true;
    }
    const subSectionList = section.ListOfFormSubSections;
    subSectionsContent.push(
      this.generateSubSectionHtml(section, subSectionList, i === this.lastIdx, idx, false)
    );
    subSectionsContentForHtml.push(
      this.generateSubSectionHtml(section, subSectionList, i === this.lastIdx, idx, true)
    );
  }
  this.ReviewHtmlString.push(subSectionsContentForHtml);
  // FINAL STABLE STRUCTURE
  return (
    <div className="bxp-summary-root-container">
      {/* Step Indicator Slot */}
      {!this.state.isSubmit && (
        <StepIndicator
          key="bxp-step-indicator"
          withbackbtn={true}
          title="Back"
          sectionSequence={stepNumer}
          section={sectionList[stepNumer + 1]}
          callback={currentStep => { this.props.callbackStepIndex(currentStep) }}
          programContainer={this.programContainer}
          isEng={this.props.isEng}
        />
      )}

      {/* Summary Header */}
      {summaryHeaderSlot}

      {/* Error Alerts */}
      <ErrorAlertsComponent
        key="summary-error-alerts"
        errorMsgList={this.state.validationErrMsg}
        isEng={this.props.isEng}
      />

      {/* Subsections Content*/}
      <div key="subsections-list-wrapper">
        {subSectionsContent}
      </div>

      {/* Bottom Buttons */}
      <div key="summary-footer-actions">
            <button
              className="ontario-button ontario-button--primary"
              id="submit-btn"
              type="button"
              aria-label={this.props.isEng ? (this.showComplete ? "Complete" : "Submit") : (this.showComplete ? "Compléter" : "Soumettre")}
              onClick={async () => {
                this.setState({ isSubmit: true });
                const ok = await this.handleSubmit();
                if (!ok) {
                  this.setState({ isSubmit: false });
                } else {
                  this.setState({ submitProgress: 5 });
                  const progressTimer = setInterval(() => {
                    this.setState(prev => ({
                      submitProgress: Math.min((prev.submitProgress ?? 0) + 5, 95),
                    }));
                  }, 400);
                  const ret = await this.saveDraft(true, this.ReviewHtmlString); 
                  clearInterval(progressTimer);
                  this.setState({
                    submitProgress: ret ? 100 : 0,
                    isSubmit: ret,
                  });

                }
              }}
            >
              {this.props.isEng ? (this.showComplete ? "Complete" : "Submit") : (this.showComplete ? "Compléter" : "Soumettre")}
            </button>
            <button
              className="ontario-button ontario-button--secondary"
              id="save-draft-btn"
              type="button"
              aria-label={this.props.isEng ? "Save as draft" : "Sauvegarder"}
              onClick={async() => {
                this.setState({ isBusy: true });
                const ret=await this.saveDraft(false, [""]);
                if(!ret){
                  this.setState({ isBusy: false });
                }
              }}
            >
              {this.props.isEng ? "Save as draft" : "Sauvegarder"}
            </button>
      </div>
      <div className="bxp-summary-root-container">
        {this.renderSubmitProgressModal()}
      </div>
      <div>
        <SpinnerComponent isBusy={this.state.isBusy} />
      </div>
    </div>
  );
}

  hideElementInSummary = (islastIdx, elements: FormSectionElements[]) => {
    elements.forEach((p:FormSectionElements) => {
        if (
          p.Datatype === "Picture" ||
          p.Datatype === "HTML" ||
          p.Datatype === "Label" ||
          p.Datatype === "Button" ||
          p.Datatype === "SuccessAlert" ||
          p.Datatype === "ErrorAlert" ||
          p.Datatype === "InformationAlert" ||
          p.Datatype === "Accordions"
        ) {
          !islastIdx && (p.hideInSummary = true);
        } else if(p.Datatype === "Row") {
          if(p.subSectionList && p.subSectionList.length > 0) {
            p.subSectionList.forEach((subSection: FormSubSections) => {
              this.hideElementInSummary(islastIdx, subSection.ListOfFormSectionElements);

            });
          }
        }
      });

  }

generateSubSectionHtml = (section: FormSections, subSectionList, islastIdx: boolean, sectionIndex: number,forHtml:boolean) => {
  let title = this.props.isEng ? section.ENUTitle : section.FRATitle;
  const stepIndex = sectionIndex;
  title = title.replace(
    /(Step|Étape)\s*(\d+)(:?\s*)/i,
    (_, prefix, _num, suffix) =>
      `${prefix} ${stepIndex !== undefined ? stepIndex : ""}${suffix}`
  );

  const validSubSections = subSectionList.map((subSection) => {

    subSection.originalElements = [...subSection.ListOfFormSectionElements];

    this.hideElementInSummary(islastIdx, subSection.ListOfFormSectionElements);
    return subSection;
  });

  if (validSubSections.length === 0) return null;

  return (
    <section className="avoid-break" key={"summary_section_${section.Id}"}>
      {section.Visible && (
        <>
          <div style={{ 
            display: "flex", 
            justifyContent: "space-between", 
            borderBottom: "#d5d5d5 solid .18rem", 
            paddingTop: "8px" 
          }}>
            {this.props.programContainer.isHorizontalLayout ? (
              <div className="ontario-bg-greyscale-40">
                <span className="ontario-h4">{title}</span>
              </div>
            ) : (
              <span className="ontario-h4">{title}</span>
            )}
            
            {title && !forHtml && !islastIdx && (
              <a href="#"
                onClick={(e) => {
                  e.preventDefault();
                  if (this.props.parentRef?.handleBXPSummaryCallback) {
                    validSubSections.forEach((sub) => {
                      sub.ListOfFormSectionElements = sub.originalElements || sub.ListOfFormSectionElements;
                    });
                    const firstSub = validSubSections[0];
                    this.props.parentRef.handleBXPSummaryCallback(firstSub.parent, firstSub.parent.Sequence - 1);
                  }
                }}
              >
                {this.props.isEng ? "Change" : "Changement"}
              </a>
            )}
          </div>

          {validSubSections.map((subSection) => (
            <SubSectionComponent
              key={"review_DetailComponent_" + subSection.Id}
              isEng={this.props.isEng}
              {...this.props}
              activeSubSection={subSection}
              editable={!forHtml && islastIdx}
              roleBasedEditable={false}
              roleBased={false}
              ownerEditableOnly={true}
              user={null}
              topEntity={{}}
              style={{
                display: subSection.Visible === false ? "none" : "block",
                ...(this.props.programContainer?.CategoryId?.toUpperCase().startsWith("BXP") && { flex: 1 }),
              }}
              callback={(programContainer: ProgramContainer) => {
              this.props.callback(programContainer);
          }}           
           />
          ))}
        </>
      )}
    </section>
  );
};


  handleSubmit = async (): Promise<boolean> => {

    const invalidControlList = FormValidationUtils.invalidControls(
      this.props.programContainer.ListOfFormSections[this.lastIdx]
    );

    if (invalidControlList.length > 0) {
      this.setState({ validationErrMsg: invalidControlList });
      window.scrollTo(0, 0);
      return false;
    } else {
      this.setState({ validationErrMsg: [] });
      return true;
    }
  };

  saveDraft = async (isSubmit: boolean = false, html: string[]) : Promise<boolean> => {
    try {
      if (this.props.parentRef && this.props.parentRef.saveToServer) {
        return await this.props.parentRef.saveToBXPServer(isSubmit, html);
      } else {
        throw new Error("saveToServer function is not available.");
      }
    } catch (error) {
      console.error("Error saving draft:", error);
      return false
    }
  };

   renderSubmitProgressModal = () => {
    if (!this.state.isSubmit) return null;

    return (
      <div style={overlayStyle}>
        <div style={modalStyle}>
          <h3>{this.props.isEng ? ( this.showComplete? "Completing…":"Submitting…") : ( this.showComplete?"Complétement…":"Soumission en cours…")}</h3>

          <div style={{ marginTop: "16px" }}>
            <progress
              value={this.state.submitProgress ?? 0}
              max={100}
              style={{ width: "100%" }}
            />
          </div>

          <p style={{ marginTop: "12px" }}>
            {this.props.isEng ? "Please wait, do not refresh the page." : "Veuillez patienter, ne pas actualiser la page."}
          </p>
        </div>
      </div>
    );
  }

}

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modalStyle: React.CSSProperties = {
  background: "#fff",
  padding: "24px",
  borderRadius: "8px",
  width: "320px",
  textAlign: "center",
};
